import { render, staticRenderFns } from "./FeeService.vue?vue&type=template&id=4c84063c&scoped=true&"
import script from "./FeeService.vue?vue&type=script&lang=js&"
export * from "./FeeService.vue?vue&type=script&lang=js&"
import style0 from "./FeeService.vue?vue&type=style&index=0&id=4c84063c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c84063c",
  null
  
)

export default component.exports